'use client';

/**
 * Загрузка и отказ отчёта.
 *
 * Отдельный вид у 404 без тела: ручки нет в собранном бэкенде. При выкатке,
 * когда фронт ушёл вперёд, «не найдено» отправит искать данные, хотя чинится
 * это пересборкой бэкенда.
 */

import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import { ApiError } from '@/lib/api/client';

export function ReportLoading({ height = 200 }: { height?: number }) {
  return (
    <div className="flex items-center justify-center" style={{ height }}>
      <Loader2 size={20} className="animate-spin text-slate-300" />
    </div>
  );
}

export function ReportError({ error, height = 200 }: { error: unknown; height?: number }) {
  const missingEndpoint = error instanceof ApiError && error.isMissingEndpoint;

  return (
    <div
      className="flex flex-col items-center justify-center gap-2 text-center px-6"
      style={{ height }}
    >
      <AlertCircle size={22} className="text-red-300" />
      <span className="text-xs text-slate-600">
        {missingEndpoint
          ? 'Этой ручки нет в собранном бэкенде — отчёты появятся после его обновления'
          : error instanceof ApiError
            ? error.message
            : 'Не удалось загрузить отчёт'}
      </span>
    </div>
  );
}
